/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TransportAutoCarFrontIcon24Solid = forwardRef('TransportAutoCarFrontIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.653 9 19.38 5.075A3 3 0 0 0 16.527 3H7.473A3 3 0 0 0 4.62 5.075L3.347 9H1.5a1.5 1.5 0 1 0 0 3H2v8a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-1h10v1a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-8h.5a1.5 1.5 0 0 0 0-3h-1.847ZM4.455 12a1 1 0 0 1 1-1H8a1 1 0 1 1 0 2H5.455a1 1 0 0 1-1-1ZM16 11a1 1 0 1 0 0 2h2.489a1 1 0 1 0 0-2H16Z" })));
});
